import React from 'react'

import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'
import { NextPage } from 'next'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { PageProps } from 'types/page'
import { SearchHistory } from 'experiences/search/History'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { useLoginRequired } from 'services/Authentication/hooks/useLoginRequired'

const SearchHistoryPage: NextPage<PageProps> = ({ metaTags }): JSX.Element => {
	useLoginRequired()

	return (
		<StandardLayout metaTags={metaTags}>
			<DashboardLayout ssrDisplay={true}>
				<SearchHistory />
			</DashboardLayout>
		</StandardLayout>
	)
}

export const getServerSideProps = defaultSSRProps

export default SearchHistoryPage
